import type {
  Empfaengerkreis,
  EmpfaengerVorschau,
  Rundnachricht,
  RundnachrichtArt,
} from '@genealogy-app/shared';
import apiClient from './client';

// ─── Rundnachrichten ─────────────────────────────────────────────────────────

export interface RundnachrichtenAntwort {
  nachrichten: Rundnachricht[];
  /** Die gerade laufende Nachricht, falls es eine gibt. */
  laufendeId: string | null;
}

export async function fetchRundnachrichten(): Promise<RundnachrichtenAntwort> {
  const { data } = await apiClient.get<RundnachrichtenAntwort>('/rundnachrichten');
  return data;
}

export async function fetchRundnachricht(id: string): Promise<Rundnachricht> {
  const { data } = await apiClient.get<Rundnachricht>(`/rundnachrichten/${id}`);
  return data;
}

export async function fetchVorschau(
  kreis: Empfaengerkreis & { art: RundnachrichtArt },
): Promise<EmpfaengerVorschau> {
  const { data } = await apiClient.post<EmpfaengerVorschau>('/rundnachrichten/vorschau', kreis);
  return data;
}

/** Ziel und Beschriftung der Schaltfläche unter dem Text. */
export interface Linkfelder {
  linkUrl: string | null;
  linkText: string | null;
}

export async function sendeProbe(entwurf: {
  art: RundnachrichtArt;
  betreff: string;
  text: string;
} & Linkfelder): Promise<{ an: string }> {
  const { data } = await apiClient.post<{ an: string }>('/rundnachrichten/probe', entwurf);
  return data;
}

export async function sendeRundnachricht(
  entwurf: Empfaengerkreis & {
    art: RundnachrichtArt;
    betreff: string;
    text: string;
    /** Die Zahl, die dem Betreiber angezeigt wurde – der Server prüft sie gegen. */
    bestaetigteAnzahl: number;
  } & Linkfelder,
): Promise<Rundnachricht> {
  const { data } = await apiClient.post<Rundnachricht>('/rundnachrichten', entwurf);
  return data;
}
